import Vue from "vue";
import Router from "vue-router";
import ConfigRouter from "./configRouter";
import CommonRouter from "./common";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import utils from "@/utils";
const { getJumpPath, globalRem } = utils;
import store from "@/store";

const jumpPaths = new Map([
  // 当前路由   互跳的路由   当前路由对应的页面类型
  ["home", ["homeH5", "pc"]],
  ["homeH5", ["home", "h5"]],
  ["login", ["login_h5", "pc"]],
  ["login_h5", ["login", "h5"]],
  ["signup", ["signup_h5", "pc"]],
  ["signup_h5", ["signup", "h5"]],
  ["findpwd", ["findpwd_h5", "pc"]],
  ["findpwd_h5", ["findpwd", "h5"]],
  ["servicePC", ["serviceH5", "pc"]],
  ["serviceH5", ["servicePC", "h5"]],
  ["servicePCHistory", ["serviceH5History", "pc"]],
  ["serviceH5History", ["servicePCHistory", "h5"]],
  ["servicePCInfo", ["serviceH5Info", "pc"]],
  ["serviceH5Info", ["servicePCInfo", "h5"]],
  ["servicePCOrderDetail", ["serviceH5OrderDetail", "pc"]],
  ["serviceH5OrderDetail", ["servicePCOrderDetail", "h5"]],
  ["servicePCQuestion", ["serviceH5Question", "pc"]],
  ["serviceH5Question", ["servicePCQuestion", "h5"]],
  ["servicePCRequestion", ["serviceH5Requestion", "pc"]],
  ["serviceH5Requestion", ["servicePCRequestion", "h5"]],
  ["about", ["aboutH5", "pc"]],
  ["aboutH5", ["about", "h5"]],
  ["terms", ["termsH5", "pc"]],
  ["termsH5", ["terms", "h5"]],
  ["privacy_policy", ["privacy_policyH5", "pc"]],
  ["privacy_policyH5", ["privacy_policy", "h5"]],
  ["siteinfo", ["siteinfoH5", "pc"]],
  ["siteinfoH5", ["siteinfo", "h5"]],
  ["tokusyouhouPC", ["tokusyouhouH5", "pc"]],
  ["tokusyouhouH5", ["tokusyouhouPC", "h5"]],

  ["news",["newsH5","pc"]],
  ["newsH5",["news","h5"]],
  ["newsDetail",["newsDetailH5","pc"]],
  ["newsDetailH5",["newsDetail","h5"]],
  ["newsPreDetail",["newsPreDetailH5","pc"]],
  ["newsPreDetailH5",["newsPreDetail","h5"]],
  ["active",["activeH5","pc"]],
  ["activeH5",["active","h5"]],
  ["activePreDetail",["activePreDetailH5","pc"]],
  ["activePreDetailH5",["activePreDetail","h5"]],
  ["activeDetail",["activeDetailH5","pc"]],
  ["activeDetailH5",["activeDetail","h5"]],

  ["gamelist_h5", ["home", "h5"]],
  ["fansH5", ["home", "h5"]],
  ["paygame", ["pay_h5", "pc"]],
  ["pay_h5", ["paygame", "h5"]],
  ["pay_h5Setoutpay", ["paygame", "h5"]],
  ["pay_h5Pgrecord", ["paygame_history", "h5"]],
  ["paygame_history", ["pay_h5Pgrecord", "pc"]],
  ["pay_h5Payorder", ["paygame_history", "h5"]],
  ["pay_h5Paycomplete", ["paygame_history", "h5"]],
  ["pay_h5Paysucceed", ["paygame_history", "h5"]],
  ["pay_h5Payaffirm", ["paygame", "h5"]],
]);

const passportRoutes = [
  "login",
  "appleLoginCallBack",
  "login_h5",
  "signup",
  "signup_h5",
  "findpwd",
  "findpwd_h5",
  "account",
];

const backbarRoutes = [
  "login_h5",
  "signup_h5",
  "findpwd_h5",
  "serviceH5Requestion",
  "serviceH5OrderDetail",
];

const siteConfig = require("@configs");

Vue.use(Router);

export const router = new Router({
  linkActiveClass: "router-link-active",
  mode: "history",
  base: process.env.BASE_URL,
  routes: [...ConfigRouter, ...CommonRouter],
  scrollBehavior: () => ({ x: 0, y: 0 }),
});

router.beforeEach(async (to, from, next) => {
  // 统一处理需要登陆态的未登录时跳转
  // if (to.meta.needLogin && !token("joy_jct")) {
  //   next({
  //     path: "/login",
  //     query: {
  //       redirect: location.href
  //     }
  //   });
  // }
  if (to.meta.needLogin) {
    store.dispatch("getUserInfo", true);
  }

  // 判断应用backbar的路由通知根vue显示或者隐藏header.vue
  // 使用 backbar的路由不使用 header
  if (backbarRoutes.includes(to.name)) {
    store.dispatch("setH5HeaderStatus", false);
    store.dispatch("setH5BackbarStatus", true);
  } else {
    store.dispatch("setH5HeaderStatus", true);
    store.dispatch("setH5BackbarStatus", false);
  }

  // admin 已迁移至专门客服M端项目
  // admin 模块的路由均不显示 header、 footer
  // if (to.path.startsWith("/admin")) {
  //   store.dispatch("setHeaderStatus", false);
  //   store.dispatch("setFooterStatus", false);
  // } else {
  //   store.dispatch("setHeaderStatus", true);
  //   store.dispatch("setFooterStatus", true);
  // }

  if (to.name === "home") {
    store.dispatch("setFooterStatus", false);
  }

  // 不是东南亚时才去处理和passport域名的互跳，其他没有登陆页专用域名的也要加在这个判断中
  if (siteConfig.domain.indexOf(".komoejoy-sea.com") < 0) {
    // 判断是否包含passport域名
    if (!window.location.href.includes(siteConfig.passportDomain)) {
      // 判断是否是passport域名，不是的话跳转至passport域名
      // 判断是否包含passport的路由
      if (passportRoutes.includes(to.name)) {
        window.location.href = `https://${siteConfig.passportDomain}${to.fullPath}`;
        // window.location.href = `http://${siteConfig.passportDomain}${to.fullPath}`;
        // NProgress.done();
        return;
      }
    } else {
      if (!passportRoutes.includes(to.name)) {
        window.location.href = `https://${siteConfig.domain}${to.fullPath}`;
        // window.location.href = `http://${siteConfig.domain}${to.fullPath}`;
        // NProgress.done();
        return;
      }
    }
  }
  // 处理双端互跳
  if (jumpPaths.has(to.name)) {
    const toName = getJumpPath(to.name, jumpPaths);
    if (toName && toName !== from.name) {
      // NProgress.done();
      next({
        name: toName,
        query: to.query,
        replace: true,
      });

      return;
    }
  }
  // 处理h5 rem
  const toRoute = router.options.routes.find((path) => path.name === to.name);
  const fromRoute = router.options.routes.find(
    (path) => path.name === from.name
  );
  if (toRoute && toRoute.baseWidth) {
    if (
      !fromRoute ||
      (fromRoute && fromRoute.baseWidth !== toRoute.baseWidth)
    ) {
      globalRem(toRoute.baseWidth, toRoute.baseHeight || null);
    }
  } else {
    globalRem(null);
  }

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  // 路由切换时修改页面标题
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }
  NProgress.start();
  // NProgress.done();
  next();
});
router.afterEach(() => {
  NProgress.done();
});
